import { render, staticRenderFns } from "./DocumentImagePreviewPopup.vue?vue&type=template&id=12eebb45&scoped=true"
import script from "./DocumentImagePreviewPopup.vue?vue&type=script&lang=ts"
export * from "./DocumentImagePreviewPopup.vue?vue&type=script&lang=ts"
import style0 from "./DocumentImagePreviewPopup.vue?vue&type=style&index=0&id=12eebb45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eebb45",
  null
  
)

export default component.exports